document.addEventListener("turbolinks:load", () => {
  const form = document.querySelector("form[data-pb-ddt-commissions-url]");
  if (!form) return;

  const customerSelect = document.getElementById("pb-ddt-customer-select");
  const tableBody = document.querySelector("#pb-ddt-details tbody");
  const addRowBtn = document.getElementById("add-pb-ddt-row");
  const template = document.getElementById("pb-ddt-row-template");

  if (!customerSelect || !tableBody || !addRowBtn || !template) return;

  const commissionsUrl = form.dataset.pbDdtCommissionsUrl;
  const productsUrl = form.dataset.pbDdtProductsUrl;
  const commissionDetailsUrl = form.dataset.pbDdtCommissionDetailsUrl;

  function closeAllAutocomplete() {
    document.querySelectorAll(".pb-autocomplete-results").forEach((box) => {
      box.innerHTML = "";
      box.classList.remove("pb-autocomplete-results-right");
    });
  }

  function closeAutocomplete(container) {
    if (!container) return;
    container.innerHTML = "";
    container.classList.remove("pb-autocomplete-results-right");
  }

  function adjustAutocompleteDirection(resultsBox) {
    if (!resultsBox) return;

    resultsBox.classList.remove("pb-autocomplete-results-right");

    requestAnimationFrame(() => {
      const rect = resultsBox.getBoundingClientRect();
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

      if (rect.right > viewportWidth) {
        resultsBox.classList.add("pb-autocomplete-results-right");
      }
    });
  }

  function normalize(value) {
    return String(value || "").trim().toLowerCase();
  }

  function fetchJson(url) {
    return fetch(url, {
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    }).then((response) => {
      if (!response.ok) throw new Error("Errore nella richiesta");
      return response.json();
    });
  }

  function rowDestroyed(row) {
    const destroyField = row.querySelector('input[name*="[_destroy]"]');
    return destroyField && String(destroyField.value) === "1";
  }

  function visibleRows() {
    return Array.from(tableBody.querySelectorAll("[data-pb-ddt-detail-row]")).filter((row) => !rowDestroyed(row));
  }

  function getCommissionSelect(row) {
    return row.querySelector(".js-pb-ddt-commission-select");
  }

  function getPbProductIdField(row) {
    return row.querySelector(".js-pb-product-id");
  }

  function getCommissionDetailIdField(row) {
    return row.querySelector(".js-commission-detail-id");
  }

  function getProductCodeField(row) {
    return row.querySelector(".js-pb-ddt-product-code");
  }

  function getDescriptionField(row) {
    return row.querySelector(".js-pb-ddt-description");
  }

  function getProductCommissionNumberField(row) {
    return row.querySelector(".js-pb-ddt-product-commission-number");
  }

  function getSerialNumberField(row) {
    return row.querySelector(".js-pb-ddt-serial-number");
  }

  function currentCustomerId() {
    return customerSelect.value || "";
  }

  function selectedCommissionId(row) {
    const select = getCommissionSelect(row);
    return select ? select.value : "";
  }

  function setRowDetailsCache(row, details) {
    row._commissionDetailsCache = Array.isArray(details) ? details : [];
  }

  function getRowDetailsCache(row) {
    return Array.isArray(row._commissionDetailsCache) ? row._commissionDetailsCache : [];
  }

  function setRowProductsCache(row, products) {
    row._productsCache = Array.isArray(products) ? products : [];
  }

  function getRowProductsCache(row) {
    return Array.isArray(row._productsCache) ? row._productsCache : [];
  }

  function clearRowProductSelection(row) {
    const pbProductIdField = getPbProductIdField(row);
    const commissionDetailIdField = getCommissionDetailIdField(row);
    const productCodeField = getProductCodeField(row);
    const descriptionField = getDescriptionField(row);
    const productCommissionNumberField = getProductCommissionNumberField(row);
    const serialNumberField = getSerialNumberField(row);

    if (pbProductIdField) pbProductIdField.value = "";
    if (commissionDetailIdField) commissionDetailIdField.value = "";
    if (productCodeField) productCodeField.value = "";
    if (descriptionField) descriptionField.value = "";
    if (productCommissionNumberField) productCommissionNumberField.value = "";
    if (serialNumberField) serialNumberField.value = "";

    row._selectedCommissionDetail = null;
    row._selectedProduct = null;
    closeAllAutocomplete();
  }

  function fillRowFromCommissionDetail(row, detail, forceField = null) {
    const commissionDetailIdField = getCommissionDetailIdField(row);
    const pbProductIdField = getPbProductIdField(row);

    const productCodeField = getProductCodeField(row);
    const descriptionField = getDescriptionField(row);
    const productCommissionNumberField = getProductCommissionNumberField(row);
    const serialNumberField = getSerialNumberField(row);

    if (commissionDetailIdField) commissionDetailIdField.value = detail.id || "";
    if (pbProductIdField) pbProductIdField.value = detail.pb_product_id || "";

    if (productCodeField && (forceField === "product_code" || !productCodeField.value.trim())) {
      productCodeField.value = detail.product_code || "";
    }

    if (descriptionField && (forceField === "description" || !descriptionField.value.trim())) {
      descriptionField.value = detail.description || "";
    }

    if (
      productCommissionNumberField &&
      (forceField === "product_commission_number" || !productCommissionNumberField.value.trim())
    ) {
      productCommissionNumberField.value = detail.product_commission_number || "";
    }

    if (serialNumberField && (forceField === "serial_number" || !serialNumberField.value.trim())) {
      serialNumberField.value = detail.serial_number || "";
    }

    row._selectedCommissionDetail = detail;
    row._selectedProduct = null;
  }

  function fillRowFromProduct(row, product, forceField = null) {
    const pbProductIdField = getPbProductIdField(row);
    const commissionDetailIdField = getCommissionDetailIdField(row);

    const productCodeField = getProductCodeField(row);
    const descriptionField = getDescriptionField(row);
    const productCommissionNumberField = getProductCommissionNumberField(row);
    const serialNumberField = getSerialNumberField(row);

    if (pbProductIdField) pbProductIdField.value = product.id || "";
    if (commissionDetailIdField) commissionDetailIdField.value = "";

    if (productCodeField && (forceField === "product_code" || !productCodeField.value.trim())) {
      productCodeField.value = product.product_code || "";
    }

    if (descriptionField && (forceField === "description" || !descriptionField.value.trim())) {
      descriptionField.value = product.description || "";
    }

    if (productCommissionNumberField) {
      productCommissionNumberField.value = product.commission_number || "";
    }

    if (serialNumberField) {
      serialNumberField.value = "";
    }

    row._selectedCommissionDetail = null;
    row._selectedProduct = product;
  }

  function buildAutocompleteItem(detailOrProduct, matchedField, onSelect, type = "detail") {
    const item = document.createElement("div");
    item.className = "pb-autocomplete-item";

    const productCode = detailOrProduct.product_code || "";
    const description = detailOrProduct.description || "";

    const codeHtml =
      matchedField === "product_code"
        ? `<span class="pb-autocomplete-code"><strong>${productCode}</strong></span>`
        : `<span class="pb-autocomplete-code">${productCode}</span>`;

    const descriptionHtml =
      matchedField === "description"
        ? `<span class="pb-autocomplete-description"><strong>${description}</strong></span>`
        : `<span class="pb-autocomplete-description">${description}</span>`;

    let extraHtml = "";

    if (type === "detail") {
      if (detailOrProduct.product_commission_number) {
        extraHtml += matchedField === "product_commission_number"
          ? `<span class="pb-autocomplete-meta"> | Commessa: <strong>${detailOrProduct.product_commission_number}</strong></span>`
          : `<span class="pb-autocomplete-meta"> | Commessa: ${detailOrProduct.product_commission_number}</span>`;
      }

      if (detailOrProduct.serial_number) {
        extraHtml += matchedField === "serial_number"
          ? `<span class="pb-autocomplete-meta"> | Seriale: <strong>${detailOrProduct.serial_number}</strong></span>`
          : `<span class="pb-autocomplete-meta"> | Seriale: ${detailOrProduct.serial_number}</span>`;
      }
    } else {
      if (detailOrProduct.drawing_number) {
        extraHtml += `<span class="pb-autocomplete-meta"> | Disegno: ${detailOrProduct.drawing_number}</span>`;
      }

      if (detailOrProduct.commission_number) {
        extraHtml += `<span class="pb-autocomplete-meta"> | Commessa: ${detailOrProduct.commission_number}</span>`;
      }
    }

    item.innerHTML = `${codeHtml} ${descriptionHtml}${extraHtml}`;

    item.addEventListener("mousedown", (event) => {
      event.preventDefault();
      onSelect();
    });

    return item;
  }

  function renderMatches(row, fieldName, resultsBox, matches, input) {
    closeAutocomplete(resultsBox);

    matches.forEach((detail) => {
      const item = buildAutocompleteItem(detail, fieldName, () => {
        fillRowFromCommissionDetail(row, detail, fieldName);

        if (fieldName === "product_code") input.value = detail.product_code || "";
        if (fieldName === "description") input.value = detail.description || "";
        if (fieldName === "product_commission_number") input.value = detail.product_commission_number || "";
        if (fieldName === "serial_number") input.value = detail.serial_number || "";

        closeAutocomplete(resultsBox);
      }, "detail");

      resultsBox.appendChild(item);
    });

    adjustAutocompleteDirection(resultsBox);
  }

  function renderProductMatches(row, fieldName, resultsBox, matches, input) {
    closeAutocomplete(resultsBox);

    matches.forEach((product) => {
      const item = buildAutocompleteItem(product, fieldName, () => {
        fillRowFromProduct(row, product, fieldName);

        if (fieldName === "product_code") input.value = product.product_code || "";
        if (fieldName === "description") input.value = product.description || "";

        closeAutocomplete(resultsBox);
      }, "product");

      resultsBox.appendChild(item);
    });

    adjustAutocompleteDirection(resultsBox);
  }

  function findMatches(row, fieldName, term) {
    const normalizedTerm = normalize(term);
    const details = getRowDetailsCache(row);

    return details
      .filter((detail) => {
        if (!normalizedTerm.length) return true;

        if (fieldName === "product_code") {
          return normalize(detail.product_code).includes(normalizedTerm);
        }

        if (fieldName === "description") {
          return normalize(detail.description).includes(normalizedTerm);
        }

        if (fieldName === "product_commission_number") {
          return normalize(detail.product_commission_number).includes(normalizedTerm);
        }

        if (fieldName === "serial_number") {
          return normalize(detail.serial_number).includes(normalizedTerm);
        }

        return false;
      })
      .slice(0, 50);
  }

  function findProductMatches(row, fieldName, term) {
    const normalizedTerm = normalize(term);
    const products = getRowProductsCache(row);

    return products
      .filter((product) => {
        if (!normalizedTerm.length) return true;

        if (fieldName === "product_code") {
          return normalize(product.product_code).includes(normalizedTerm);
        }

        if (fieldName === "description") {
          return normalize(product.description).includes(normalizedTerm);
        }

        return false;
      })
      .slice(0, 50);
  }

  function openFullListForField(row, fieldName, input) {
    const wrap = input.closest(".pb-autocomplete-wrap");
    if (!wrap) return;

    const resultsBox = wrap.querySelector(".pb-autocomplete-results");
    if (!resultsBox) return;

    const commissionId = selectedCommissionId(row);

    if (commissionId) {
      const details = getRowDetailsCache(row);
      if (!details.length) {
        closeAutocomplete(resultsBox);
        return;
      }

      const matches = findMatches(row, fieldName, "");
      renderMatches(row, fieldName, resultsBox, matches, input);
      return;
    }

    if (fieldName !== "product_code" && fieldName !== "description") {
      closeAutocomplete(resultsBox);
      return;
    }

    const products = getRowProductsCache(row);
    if (!products.length) {
      closeAutocomplete(resultsBox);
      return;
    }

    const matches = findProductMatches(row, fieldName, "");
    renderProductMatches(row, fieldName, resultsBox, matches, input);
  }

  function initAutocompleteInput(input, fieldName) {
    if (!input || input.dataset.pbDdtAutocompleteInit === "1") return;
    input.dataset.pbDdtAutocompleteInit = "1";

    input.addEventListener("focus", function () {
      const row = this.closest("[data-pb-ddt-detail-row]");
      if (!row) return;
      openFullListForField(row, fieldName, this);
    });

    input.addEventListener("click", function () {
      const row = this.closest("[data-pb-ddt-detail-row]");
      if (!row) return;
      openFullListForField(row, fieldName, this);
    });

    input.addEventListener("input", function () {
      const row = this.closest("[data-pb-ddt-detail-row]");
      if (!row) return;

      const wrap = this.closest(".pb-autocomplete-wrap");
      if (!wrap) return;

      const resultsBox = wrap.querySelector(".pb-autocomplete-results");
      if (!resultsBox) return;

      const commissionId = selectedCommissionId(row);
      const term = this.value.trim();

      if (commissionId) {
        const currentDetailId = getCommissionDetailIdField(row)?.value;

        if (!term.length && !currentDetailId) {
          openFullListForField(row, fieldName, this);
          return;
        }

        const matches = findMatches(row, fieldName, term);
        renderMatches(row, fieldName, resultsBox, matches, this);
        return;
      }

      if (fieldName !== "product_code" && fieldName !== "description") {
        closeAutocomplete(resultsBox);
        return;
      }

      const currentProductId = getPbProductIdField(row)?.value;

      if (!term.length && !currentProductId) {
        openFullListForField(row, fieldName, this);
        return;
      }

      const matches = findProductMatches(row, fieldName, term);
      renderProductMatches(row, fieldName, resultsBox, matches, this);
    });

    input.addEventListener("blur", function () {
      const wrap = this.closest(".pb-autocomplete-wrap");
      if (!wrap) return;

      const resultsBox = wrap.querySelector(".pb-autocomplete-results");
      setTimeout(() => closeAutocomplete(resultsBox), 200);
    });
  }

  function initRowAutocompletes(row) {
    initAutocompleteInput(getProductCodeField(row), "product_code");
    initAutocompleteInput(getDescriptionField(row), "description");
    initAutocompleteInput(getProductCommissionNumberField(row), "product_commission_number");
    initAutocompleteInput(getSerialNumberField(row), "serial_number");
  }

  function updateCommissionOptionsForRow(row, commissions, preserveValue = true) {
    const select = getCommissionSelect(row);
    if (!select) return;

    const previousValue = preserveValue ? select.value : "";

    let html = '<option value="">Seleziona commessa</option>';
    commissions.forEach((commission) => {
      html += `<option value="${commission.id}">${commission.commission_number}</option>`;
    });

    select.innerHTML = html;

    if (preserveValue && previousValue && commissions.some((c) => String(c.id) === String(previousValue))) {
      select.value = previousValue;
    } else {
      select.value = "";
      clearRowProductSelection(row);
      setRowDetailsCache(row, []);
    }
  }

  function loadCommissionsForCustomer(customerId, options = {}) {
    const preserveSelectedCommissions = options.preserveSelectedCommissions !== false;

    if (!customerId) {
      visibleRows().forEach((row) => {
        updateCommissionOptionsForRow(row, [], false);
        clearRowProductSelection(row);
        setRowDetailsCache(row, []);
      });
      return Promise.resolve([]);
    }

    return fetchJson(`${commissionsUrl}?customer_id=${encodeURIComponent(customerId)}`)
      .then((commissions) => {
        visibleRows().forEach((row) => {
          updateCommissionOptionsForRow(row, commissions, preserveSelectedCommissions);
        });
        return commissions;
      })
      .catch((error) => {
        console.error("Errore caricamento commissioni:", error);
        visibleRows().forEach((row) => {
          updateCommissionOptionsForRow(row, [], false);
          clearRowProductSelection(row);
          setRowDetailsCache(row, []);
        });
        return [];
      });
  }

  function loadProductsForCustomer(customerId) {
    if (!customerId) {
      visibleRows().forEach((row) => {
        setRowProductsCache(row, []);
      });
      return Promise.resolve([]);
    }

    return fetchJson(`${productsUrl}?customer_id=${encodeURIComponent(customerId)}`)
      .then((products) => {
        visibleRows().forEach((row) => {
          setRowProductsCache(row, products);
        });
        return products;
      })
      .catch((error) => {
        console.error("Errore caricamento prodotti:", error);
        visibleRows().forEach((row) => {
          setRowProductsCache(row, []);
        });
        return [];
      });
  }

  function loadCommissionDetailsForRow(row, commissionId, options = {}) {
    const preserveSelection = options.preserveSelection === true;
    const currentCommissionDetailId = preserveSelection ? getCommissionDetailIdField(row)?.value : "";

    if (!commissionId) {
      setRowDetailsCache(row, []);
      clearRowProductSelection(row);
      return Promise.resolve([]);
    }

    return fetchJson(`${commissionDetailsUrl}?commission_id=${encodeURIComponent(commissionId)}`)
      .then((details) => {
        setRowDetailsCache(row, details);

        if (currentCommissionDetailId) {
          const selectedDetail = details.find((detail) => String(detail.id) === String(currentCommissionDetailId));
          if (selectedDetail) {
            fillRowFromCommissionDetail(row, selectedDetail);
            return details;
          }
        }

        clearRowProductSelection(row);
        return details;
      })
      .catch((error) => {
        console.error("Errore caricamento prodotti della commessa:", error);
        setRowDetailsCache(row, []);
        clearRowProductSelection(row);
        return [];
      });
  }

  function initializeExistingRows() {
    visibleRows().forEach((row) => {
      initRowAutocompletes(row);
    });
  }

  function initializeExistingCommissionDetails() {
    const loaders = visibleRows().map((row) => {
      initRowAutocompletes(row);

      const commissionId = selectedCommissionId(row);
      if (!commissionId) {
        setRowDetailsCache(row, []);
        return Promise.resolve([]);
      }

      return loadCommissionDetailsForRow(row, commissionId, { preserveSelection: true });
    });

    return Promise.all(loaders);
  }

  function buildNewRow() {
    const time = new Date().getTime();
    return template.innerHTML.replace(/NEW_RECORD/g, time);
  }

  addRowBtn.addEventListener("click", () => {
    tableBody.insertAdjacentHTML("beforeend", buildNewRow());

    const rows = tableBody.querySelectorAll("[data-pb-ddt-detail-row]");
    const row = rows[rows.length - 1];
    if (!row) return;

    initRowAutocompletes(row);
    setRowDetailsCache(row, []);
    setRowProductsCache(row, []);

    const customerId = currentCustomerId();
    if (!customerId) return;

    loadProductsForCustomer(customerId).then(() => {
      return loadCommissionsForCustomer(customerId);
    }).then(() => {
      const select = getCommissionSelect(row);
      if (select && select.value) {
        loadCommissionDetailsForRow(row, select.value);
      }
    });
  });

  tableBody.addEventListener("click", (event) => {
    const removeBtn = event.target.closest(".remove-pb-ddt-row");
    if (!removeBtn) return;

    const row = removeBtn.closest("[data-pb-ddt-detail-row]");
    if (!row) return;

    const destroyField = row.querySelector('input[name*="[_destroy]"]');
    if (destroyField) destroyField.value = "1";

    row.style.display = "none";
    closeAllAutocomplete();
  });

  tableBody.addEventListener("change", (event) => {
    const commissionSelect = event.target.closest(".js-pb-ddt-commission-select");
    if (!commissionSelect) return;

    const row = commissionSelect.closest("[data-pb-ddt-detail-row]");
    if (!row) return;

    clearRowProductSelection(row);
    setRowDetailsCache(row, []);

    if (!commissionSelect.value) return;

    loadCommissionDetailsForRow(row, commissionSelect.value);
  });

  customerSelect.addEventListener("change", () => {
    closeAllAutocomplete();

    const customerId = currentCustomerId();

    loadProductsForCustomer(customerId)
      .then(() => {
        return loadCommissionsForCustomer(customerId, { preserveSelectedCommissions: false });
      })
      .then(() => {
        visibleRows().forEach((row) => {
          const commissionId = selectedCommissionId(row);
          if (commissionId) {
            loadCommissionDetailsForRow(row, commissionId);
          }
        });
      });
  });

  document.addEventListener("click", (event) => {
    if (!event.target.closest(".pb-autocomplete-wrap")) {
      closeAllAutocomplete();
    }
  });

  initializeExistingRows();

  const initialCustomerId = currentCustomerId();
  if (initialCustomerId) {
    loadProductsForCustomer(initialCustomerId)
      .then(() => loadCommissionsForCustomer(initialCustomerId, { preserveSelectedCommissions: true }))
      .then(() => {
        initializeExistingCommissionDetails();
      });
  } else {
    visibleRows().forEach((row) => {
      updateCommissionOptionsForRow(row, [], false);
      setRowProductsCache(row, []);
      setRowDetailsCache(row, []);
      clearRowProductSelection(row);
    });
  }
});